import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Marquee from 'react-fast-marquee';
import * as Yup from 'yup';
import { ThongBaoTrangLogin } from '../../models/home/Home';
import { layDanhSachThongBaoTaiTrangLogin } from '../../services/home';
import { quenMatKhau } from '../../services/nguoidung';
import React from "react";

const ForgotPassword = () => {
    
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev="" />;
    const [loading, setLoading] = useState(false);
    const [thongBao, setThongBao] = useState("");
    const [classThongBao, setClassThongBao] = useState<string>('');
    const [dsThongBao, setDsThongBao] = useState<Array<ThongBaoTrangLogin>>([]);

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            email: '',
            userName: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Vui lòng nhập đúng định dạng email').required('Bắt buộc'),
            userName: Yup.string().required('Bắt buộc')
        }),
        onSubmit: (values) => {
            forgotPassword(values.email, values.userName);
        }
    });

    const forgotPassword = async (email: string, userName: string) => {
        setLoading(true);
        setThongBao("");
        setClassThongBao("");
        var rs = await quenMatKhau(email, userName);
        setLoading(false);
        if (rs) {
            setThongBao('Đã cấp lại mật khẩu, hãy kiểm tra tin nhắn trong Email.');
            setClassThongBao('badge badge-success');
        }
        else {
            setThongBao('Thông tin không tồn tại trong hệ thống. Vui lòng kiểm tra lại!');
            setClassThongBao('badge badge-warning');
        }
    }

    const layDSThongBao = async () => {
        let rs = await layDanhSachThongBaoTaiTrangLogin();
        setDsThongBao(rs);
    }

    useEffect(() => {
        layDSThongBao();
    }, []);

    return (
        <>
            <div className="marquee-login-text-container">
                <Marquee pauseOnHover gradient={false} speed={40}>
                    <strong>
                        {dsThongBao?.length === 1
                            ? dsThongBao[0].noiDung
                            : (
                                <>
                                    {dsThongBao?.map((item, index) => (
                                        <React.Fragment key={index}>
                                            [{index + 1}]-{item.noiDung}
                                            {index < dsThongBao.length - 1 && <span style={{ marginRight: "20px" }} />}
                                        </React.Fragment>
                                    ))}
                                    <span style={{ marginRight: "300px" }} />
                                </>
                            )}
                    </strong>
                </Marquee>
            </div>
            <div className="container-login focus" style={{ maxWidth: "100%" }}>
            <span className="big-circle"></span>
            <div className="form-login">
                    <div className="contact-info">
                        <img src="/img/logo-text-ddif.png" style={{ marginBottom: "25px", width: "90%" }} />
                    <br/>
                    <h3 className="title-contact-info">Hệ thống quản lý nhân sự</h3>
                    <div className="info">
                        <div className="information-login">
                            <img src="img/location.png" className="icon-login" alt="" />
                            <span className="no-wrap-text-login">Số 18 Yên Bái, phường Hải Châu, thành phố Đà Nẵng</span>
                        </div>
                        <div className="information-login">
                            <img src="img/email.png" className="icon-login" alt="" />
                            <span>ddif@danang.gov.vn </span>
                        </div>
                        <div className="information-login">
                            <img src="img/phone.png" className="icon-login" alt="" />
                            <span>0236.3.888.769</span>
                        </div>
                        <div className="information-login">
                            <i className="icon-login fa fa-globe" style={{ fontSize: "27px" }} aria-hidden="true"></i>
                            <a style={{ color: "white" }} href="https://www.ddif.com.vn/" target="_blank">
                                https://www.ddif.com.vn/
                            </a>
                        </div>
                    </div>
                </div>
                <div className="contact-form">
                    <span className="circle one"></span>
                    <span className="circle two"></span>
                    <form onSubmit={handleSubmit}  id="form-submit-login">
                        <p>Vui lòng cung cấp email và tên đăng nhập đã đăng ký trong hồ sơ, chúng tôi sẽ gửi thông tin tài khoản về email cho bạn!</p>
                        <div className="mb-3">
                            <InputGroup className="mb-3">
                                <Form.Control
                                    id="email"
                                    name="email"
                                    type="text"
                                    placeholder="Email"
                                    onChange={handleChange}
                                    value={values.email}
                                    isValid={touched.email && !errors.email}
                                    isInvalid={touched.email && !!errors.email}
                                />
                                {touched.email && errors.email ? (
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                ) : (
                                    <InputGroup.Append>
                                        <InputGroup.Text>
                                            <i className="fas fa-envelope" />
                                        </InputGroup.Text>
                                    </InputGroup.Append>
                                )}
                            </InputGroup>
                            </div>
                            <div className="mb-3">
                                <InputGroup className="mb-3">
                                    <Form.Control
                                        id="userName"
                                        name="userName"
                                        type="text"
                                        placeholder="Tên đăng nhập"
                                        onChange={handleChange}
                                        value={values.userName}
                                        isValid={touched.userName && !errors.userName}
                                        isInvalid={touched.userName && !!errors.userName}
                                    />
                                    {touched.userName && errors.userName ? (
                                        <Form.Control.Feedback type="invalid">
                                            {errors.userName}
                                        </Form.Control.Feedback>
                                    ) : (
                                        <InputGroup.Append>
                                            <InputGroup.Text>
                                                <i className="fas fa-user" />
                                            </InputGroup.Text>
                                        </InputGroup.Append>
                                    )}
                                </InputGroup>
                            </div>
                        <div className='text-center' style={{marginBottom:"15px"}}>
                        <span className={classThongBao} >{thongBao}</span>
                        </div>
                        { loading && <div className="text-center" style={{marginBottom:"15px"}}> <Spin indicator={antIcon} /> </div>}
                        <div className='text-center'>
                            <button className="btn btn-sm btn-login" type="submit" style={{ width: "200px", height:"48px"}}>
                                Cấp lại mật khẩu
                            </button>
                            <div className='my-5' style={{ width: "100%", borderTop: "1px solid #dee2e6", height: "1px", position: "relative" }}>
                            </div>
                            <div className="text-right">
                                <p style={{ textAlign: "right" }}> Đã có tài khoản? <a href="login">Đăng nhập</a></p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            </div>
        </>
    );
};

export default ForgotPassword;
